// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider_slider__mmGLV","mover":"slider_mover__2AuTR","active":"slider_active__1R3-Z"};